import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "decision-component" }
const _hoisted_2 = { class: "component-contents" }
const _hoisted_3 = { class: "component-contents__else-block" }
const _hoisted_4 = { class: "component-contents__else" }
const _hoisted_5 = { class: "component-contents__else-transition-picker" }
const _hoisted_6 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_8 = {
  key: 0,
  class: "invalid-warning"
}

import Draggable from 'vuedraggable';
import { StateViewModel } from '@/features/bots/models/designer';
import IslandBadge from './IslandBadge.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import TagBox from '@/shared/components/TagBox.vue';
import { DecisionViewModel } from '@/features/bots/models/designer/decisionViewModel';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import Decision from '@/features/bots/components/designer/Decision.vue';
import { required } from '@vuelidate/validators';
import { nanoid } from 'nanoid';
import { computed, nextTick, onMounted, PropType, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { useStore } from 'vuex';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecisionComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  emits: ["state-updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = ref<StateViewModel>({
  id: '',
  component: 'decision',
  decisions: [],
});
const decisions = ref<DecisionViewModel[]>([]);
const invalid = ref(true);
const decisionComponents = ref<Array<typeof Decision>>([]);

const validations = {
  state: {
    noMatch: {
      required,
      type: {
        required,
      },
      payload: {
        payloadValid(payload: string) {
          if (payload) {
            return !isTransitionPayloadInvalid(payload).value;
          }
          return true;
        },
      },
    },
  },
};

const $v = useVuelidate(validations, { state });
const isNoMatchRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.state.noMatch));
const isNoMatchPayloadInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.state.noMatch, 'payloadValid'),
);

const store = useStore();
const isTransitionPayloadInvalid = (payload: string) =>
  computed(() => store.getters.isTransitionPayloadInvalid(payload));

onMounted(() => {
  if (props.value && props.value.decisions) {
    state.value = props.value;
    decisions.value = state.value.decisions || [];
    invalid.value = state.value.invalid === undefined ? false : state.value.invalid;
  }
});

function addDecision() {
  const decision = {
    transition: {
      type: undefined,
      payload: undefined,
    },
    conditions: {
      type: 'and',
      conditions: [],
    },
  } as DecisionViewModel;
  decisions.value.push(decision);
  nextTick(() => decisionsChanged());
}

function deleteDecision(index: number) {
  if (decisions.value.length === 1) {
    return;
  }
  decisions.value.splice(index, 1);
  nextTick(() => decisionsChanged());
}

function updateDecision(index: number, decision: DecisionViewModel) {
  decisions.value[index] = decision;
  decisionsChanged();
}

function updateDecisionsIfChanged() {
  if (state.value.decisions !== decisions.value) {
    decisionsChanged();
  }
}

function updateNoMatch(noMatch: TransitionViewModel) {
  state.value.noMatch = noMatch;
  state.value.decisions = decisions.value;
  emitUpdatedEvent();
}

function validateDecision() {
  $v.value.$touch();
}

function createKey(decision: DecisionViewModel) {
  if (!decision.key) {
    decision.key = nanoid(7);
  }
  return decision.key;
}

function decisionsChanged() {
  state.value.decisions = decisions.value;
  emitUpdatedEvent();
}

function emitUpdatedEvent() {
  invalid.value = $v.value.$invalid;
  state.value.invalid = invalid.value;
  emit('state-updated', state.value);
}

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IslandBadge, { type: "decision" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Draggable), {
        modelValue: decisions.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((decisions).value = $event)),
        class: "component-contents__decisions-list",
        onEnd: updateDecisionsIfChanged,
        handle: ".handle",
        "item-key": "key"
      }, {
        item: _withCtx(({ element: decision, index }) => [
          (_openBlock(), _createElementBlock("div", {
            key: createKey(decision)
          }, [
            _createVNode(Decision, {
              ref_key: "decisionComponents",
              ref: decisionComponents,
              class: "component-contents__decision",
              decision: decision,
              canDelete: decisions.value.length > 1,
              onDeleted: ($event: any) => (deleteDecision(index)),
              onUpdated: (updatedDecision) => updateDecision(index, updatedDecision)
            }, null, 8, ["decision", "canDelete", "onDeleted", "onUpdated"])
          ]))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("a", {
        onClick: addDecision,
        class: "component-contents__add-condition-button"
      }, [
        _createVNode(AddIcon),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "component-contents__add-condition-label" }, "Add decision", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TagBox, { value: "else" }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TransitionPicker, {
              transition: state.value.noMatch,
              onTransitionSelected: updateNoMatch
            }, null, 8, ["transition"]),
            (isNoMatchPayloadInvalid.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Must not contain an invalid transition"))
              : (isNoMatchRequiredInvalid.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Must select a transition"))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (invalid.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(ErrorIcon, { class: "icon-1-3x" })
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_away, validateDecision]
  ])
}
}

})